<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Project information -->

    <div class="ui vertical basic segment" fxLayout="column" fxLayoutGap="25px">
      <!-- <div fxLayout="column">
                  <div fxFlex>
            <img *ngIf="company.logoPath"src="{{baseUrl}}/public/image/?media={{company.logoPath}}"  class="ui mini image">
            <img *ngIf="!company.logoPath" src="assets/avatar/1.jpg" class="ui circular tiny image">
                        </div>
            </div> -->

      <div fxLayout="column">
        <div fxFlex><strong>COMPANY NAME</strong></div>
        <div fxFlex>{{ company?.companyName }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex class="header"><strong>RC NUMBER</strong></div>
        <div fxFlex>{{ company?.companyRegNumber }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex class="header">
          <strong>TAX IDENTIFICATION NUMBER</strong>
        </div>
        <div fxFlex>{{ company?.tin }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>COMPANY TYPE </strong></div>
        <div fxFlex>{{ company.companyTypeId?.optionName }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>OWNERSHIP TYPE </strong></div>
        <div fxFlex>{{ company.ownershipType?.optionName }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>ADDRESS</strong></div>
        <div fxFlex>
          {{
            company?.headOfficeAddressStreet
              ? company.headOfficeAddressStreet
              : company?.contractor?.headOfficeAddressStreet
          }}
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>CONTACT EMAIL</strong></div>
        <div fxFlex>{{ company?.companyContactEmail }}</div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>PHONE </strong></div>
        <div fxFlex>
          {{
            company?.companyContactPhone1
              ? company?.companyContactPhone1
              : company.contractor?.phoneNumber
          }}
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>PHONE 2</strong></div>
        <div fxFlex>{{ company?.companyContactPhone2 }}</div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>WEBSITE</strong></div>
        <div fxFlex>{{ company?.contractor?.website }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>VERIFICATION STATUS</strong></div>
        <div fxFlex>
          <span
            class="ui yellow label"
            [ngClass]="{ green: company?.companyRegVerified }"
            >{{ company?.companyRegVerified }}</span
          >
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>ACTIVE STATUS</strong></div>
        <div fxFlex>
          <span
            class="ui label break"
            [ngClass]="{
              red: company?.contractor?.barred == true,
              green: company?.contractor?.barred == false
            }"
            >{{ company?.contractor?.barred ? "IN-ACTIVE" : "ACTIVE" }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="modal.approve(null)"
    autofocus
  >
    Done
  </button>
</div>
